export default __webpack_public_path__ + "static/media/movie-episode-6.4d5f1a60.jpg";